// NEVANU — Theme System
// Nur 2 Modi: light + dark. Background-Image-Feature entfernt (2026-04-21).

export type ThemeMode = 'light' | 'dark';

const THEME_KEY = 'nevanuThemeMode';

/** Aktuellen Theme-Modus holen */
export function getThemeMode(): ThemeMode {
  const stored = localStorage.getItem(THEME_KEY) as string;
  // Migrate legacy values
  if (stored === 'crazy' || stored === 'mono') {
    localStorage.setItem(THEME_KEY, 'light');
    return 'light';
  }
  return (stored as ThemeMode) || 'light';
}

/** Theme-Modus setzen */
export function setThemeMode(mode: ThemeMode): void {
  localStorage.setItem(THEME_KEY, mode);
  applyTheme(mode);
}

/** Theme-Modus durchschalten (light ↔ dark) */
export function cycleThemeMode(): ThemeMode {
  const current = getThemeMode();
  const next: ThemeMode = current === 'light' ? 'dark' : 'light';
  setThemeMode(next);
  return next;
}

/** Theme auf DOM anwenden */
export function applyTheme(mode?: ThemeMode): void {
  const m = mode || getThemeMode();
  const body = document.body;
  body.classList.remove('dark-mode', 'mono-mode');
  if (m === 'dark') {
    body.classList.add('dark-mode');
  }
}

/** Theme beim App-Start initialisieren */
export function initTheme(): void {
  applyTheme();
  // Legacy-Aufraeumung: alte BG-Keys entfernen falls vorhanden
  try {
    localStorage.removeItem('nevanuBgMode');
    localStorage.removeItem('nevanu_bg');
    localStorage.removeItem('nevanu_bg_custom_light');
    localStorage.removeItem('nevanu_bg_custom_dark');
  } catch {}
}

/** No-op Stubs — Feature entfernt, fuer Backwards-Compat exportiert */
export function getBgMode(): string { return 'none'; }
export function setBgMode(_mode: string): void {}
